export default __webpack_public_path__ + "static/apys-deb963cba5ba1108c3cadc2abfdb0084.png";